<template>
    <div> 
        <DataTable :value="statusItens" class="p-datatable-sm p-datatable-striped">   
            <template #header>
                <div class="table-header">			
                    <div class="p-d-flex p-jc-left">				
                        <Button icon="pi pi-refresh" title="Atualizar" @click="statusFila"/>        
                    </div>
                </div>
            </template>        
            <Column field="descricao" header="Item" sortable></Column>
            <Column field="quantidade" header="Quantidade" sortable></Column>
            <Column field="status" header="Status" sortable></Column> 
            <Column field="observacao" header="Obs." sortable></Column>  
            <Column>
                <template #body="slotProps">
                    <Button icon="pi pi-info-circle" title="Listar" 
                        class="p-button-rounded p-button-danger" 
                        @click="buscarItensAnalise(slotProps.data)"
                        v-if="slotProps.data.longaDuracao || slotProps.data.status == 'ERRO'"/>					
                </template>	
            </Column>             
        </DataTable> 

        <Dialog :visible.sync="exibirDialogItensAnalise" :header="titulo" :modal="true" :style="{width: '70vw'}">
			<!-- documentos-->
            <DataTable :value="analiseItens" :filters="filtro" class="p-datatable-sm p-datatable-striped" v-if="tipoDados == 'DOCUMENTO'">
                <template #header>
                    <div class="table-header">			
                        <div class="p-d-flex p-jc-between">				
                            <Button :label="'Finalizar TODOS (' + totalItens + ')'" 
                                icon="pi pi-times" 
                                title="Finalizar. Prepara para Excluir"
                                class="p-button-danger"
                                @click="confirmarAcao('EXCLUIR_TODOS')" 
                                v-if="analiseItens.length > 0"/>
                            <span class="p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="filtro['global']" placeholder="Filtrar..." />
                            </span>
                        </div>
                    </div>
                </template>
                <Column field="nome" header="Item"></Column>
                <Column field="tipo" header="Tipo"></Column>
                <Column field="dataSolicitacao" header="Data Solicitação">
                    <template #body="slotProps">
                        {{ formatarDataHora(slotProps.data.dataSolicitacao) }}
                    </template>
                </Column>	
                <Column field="dataInicioProcessamento" header="Data Início Processamento">
                    <template #body="slotProps">
                        {{ formatarDataHora(slotProps.data.dataInicioProcessamento) }}
                    </template>
                </Column>	
                <Column field="dataFinalProcessamento" header="Data Final do Processamento">
                    <template #body="slotProps">
                        {{ formatarDataHora(slotProps.data.dataFinalProcessamento) }}
                    </template>
                </Column>
                <Column field="status" header="Status"></Column>
                <Column field="mensagem" header="Obs."></Column>
                <Column>
                    <template #body="slotProps">
                        <Button label="Finalizar" icon="pi pi-times" title="Finalizar. Prepara para Excluir"
                            class="p-button-rounded p-button-danger" 
                            @click="confirmarAcao('EXCLUIR_SELECIONADO' , slotProps.data)"/>					
                    </template>	
                </Column> 
            </DataTable>

            <!-- Lotes marcações-->
            <DataTable :value="analiseItens" :filters="filtro" class="p-datatable-sm p-datatable-striped" v-if="tipoDados == 'LOTE'">
                <template #header>
                    <div class="table-header">			
                        <div class="p-d-flex p-jc-between">				
                            <div>
                                <Button :label="'Enviar TODOS para Fila (' + totalItens + ')'" 
                                    icon="pi pi-check" 
                                    title="Enviar TODOS para Fila"
                                    class="p-mr-2"
                                    @click="confirmarAcao('REENVIAR_TODOS')" 
                                    v-if="analiseItens.length > 0"/>
                                <Button :label="'Finalizar TODOS (' + totalItens + ')'" 
                                    icon="pi pi-times" 
                                    title="Finalizar. Prepara para Excluir"
                                    class="p-button-danger"
                                    @click="confirmarAcao('EXCLUIR_TODOS')" 
                                    v-if="analiseItens.length > 0"/>
                            </div>
                            <span class="p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="filtro['global']" placeholder="Filtrar..." />
                            </span>
                        </div>
                    </div>
                </template>
                <Column field="dataCriacao" header="Data" sortable>
                    <template #body="slotProps">
                        {{ formatarDataHora(slotProps.data.dataCriacao) }}
                    </template>
                </Column>
                <Column field="dataProcessamento" header="Data Processamento" sortable>
                    <template #body="slotProps">
                        {{ formatarDataHora(slotProps.data.dataProcessamento) }}
                    </template>
                </Column>
                <Column field="dataInicio" header="Data Início Ponto" sortable>
                    <template #body="slotProps">
                        {{ formatarDataHora(slotProps.data.dataInicio) }}
                    </template>
                </Column>
                <Column field="dataFinal" header="Data Final Ponto" sortable>
                    <template #body="slotProps">
                        {{ formatarDataHora(slotProps.data.dataFinal) }}
                    </template>
                </Column>
                <Column field="status" header="Status" sortable></Column>
                <Column field="tipo" header="Tipo" sortable></Column>
                <Column field="portaria" header="Portaria" sortable></Column>
                <Column field="fonte" header="Fonte" sortable></Column>     
                <Column field="numCnpj" header="Cnpj" sortable></Column>
                <Column field="pis" header="Pis/Cpf" sortable></Column> 
                <Column field="quantidadeMarcacoes" header="Marcações" sortable></Column>
                <Column>
                    <template #body="slotProps">
                        <Button icon="pi pi-check" title="Enviar para Fila"
                            class="p-button-rounded p-mr-2" 
                            @click="confirmarAcao('REENVIAR_SELECIONADO', slotProps.data)"/>
                        <Button icon="pi pi-times" title="Finalizar. Prepara para Excluir"
                            class="p-button-rounded p-button-danger" 
                            @click="confirmarAcao('EXCLUIR_SELECIONADO', slotProps.data)"/>                        					
                    </template>	
                </Column> 
            </DataTable>

            <Paginator :rows="quantidadePorPagina" :totalRecords="totalItens" @page="proximaPagina($event)"></Paginator>

			<template #footer>
				<Button label="OK" icon="pi pi-check" @click="exibirDialogItensAnalise=false"/>
			</template>
		</Dialog>
        
        <Dialog :visible.sync="exibirConfirmarExcluirSelecionado" header="Confirmar" :modal="true" :style="{width: '450px'}">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
                <span>Finalizar item selecionado?</span>
                <div class="p-field-checkbox p-mt-2">
                    <Checkbox v-model="naoExibirConfirmarExcluirSelecionado" :binary="true"/>
                    <label>Não exibir essa pergunta</label>
                </div>
            </div>
            <template #footer>
                <Button label="Não" icon="pi pi-times" class="p-button-secondary" 
                @click="exibirConfirmarExcluirSelecionado=false;naoExibirConfirmarExcluirSelecionado=false"/>
                <Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluir('EXCLUIR_SELECIONADO')" />
            </template>
        </Dialog>       

        <Dialog :visible.sync="exibirConfirmarExcluirTodos" header="Confirmar" :modal="true" :style="{width: '450px'}">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
                <span>Finalizar todos?</span>
            </div>
            <template #footer>
                <Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirConfirmarExcluirTodos=false"/>
                <Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluir('EXCLUIR_TODOS')" />
            </template>
        </Dialog>

        <Dialog :visible.sync="exibirConfirmarReenviarSelecionado" header="Confirmar" :modal="true" :style="{width: '450px'}">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle p-mr-3 ik-text-warnning" style="font-size: 2rem;" />
                <span>Reenviar item selecionado para fila?</span>
                <div class="p-field-checkbox p-mt-2">
                    <Checkbox v-model="naoExibirConfirmarReenviarSelecionado" :binary="true"/>
                    <label>Não exibir essa pergunta</label>
                </div>
            </div>
            <template #footer>
                <Button label="Não" icon="pi pi-times" class="p-button-secondary" 
                @click="exibirConfirmarReenviarSelecionado=false;naoExibirConfirmarReenviarSelecionado=false"/>
                <Button label="Sim" icon="pi pi-check" @click="reenviarLoteParaFila" />
            </template>
        </Dialog>

        <Dialog :visible.sync="exibirConfirmarReenviarTodos" header="Confirmar" :modal="true" :style="{width: '450px'}">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
                <span>Reenviar todos para fila?</span>
            </div>
            <template #footer>
                <Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirConfirmarReenviarTodos=false"/>
                <Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="reenviarLotesParaFila" />
            </template>
        </Dialog>

    </div>
</template>

<script>

import LogsManutencaoService from '@/service/LogsManutencaoService';
import { exibirMensagem, exibirMensagemSis } from '@/global';
import { mapGetters } from 'vuex';

export default {
    logsManutencaoService: null,
    data() {
        return {   
            naoExibirConfirmarExcluirSelecionado: false,
            naoExibirConfirmarReenviarSelecionado: false,
            exibirConfirmarExcluirTodos: false,
            exibirConfirmarExcluirSelecionado: false,
            exibirConfirmarReenviarTodos: false,
            exibirConfirmarReenviarSelecionado: false,
            exibirDialogItensAnalise: false,       
            titulo: 'Documentos', 
            tipoDados: 'DOCUMENTO',   
            tipoAnalise: '', 
            statusItem: '',
            itemComLongaDuracaoTabela: false,
            paginaItensAnalise: 0,
            totalItens: 0,
            quantidadePorPagina: 10,
            statusItens: [],
            analiseItens: [],
            itemSelecionado: null,
            filtro: {},     
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),     
        /**
         * 
         */
        statusFila() {
            this.logsManutencaoService.statusFila()
			.then(resp => {		               
                this.statusItens = resp.data;
			})
			.catch(erro => {exibirMensagem(this, erro)});
        },
        /**
         * 
         */
        buscarItensAnalise(itemSelecionado) {
            this.tipoDados = itemSelecionado.tipo;
            // Se o item está há muito tempo na tabela tem algo errado para analisar
            this.tipoAnalise = itemSelecionado.longaDuracao ? 'TEMPO_EXCESSIVO' : 'TODOS';            
            this.statusItem = itemSelecionado.status;
            this.paginaItensAnalise = 0;
            this.totalItens = 0;
            if(itemSelecionado.tipo == 'DOCUMENTO') {
                this.titulo = 'Documentos';
                this.buscarDocumentosAnalise();
            }
            if(itemSelecionado.tipo == 'LOTE') {
                this.titulo = 'Lote/Marcações';
                this.buscarLotesAnalise();
            }
        },
        /**
         * 
         */
        buscarDocumentosAnalise() {
            this.filtro = {};
            this.logsManutencaoService.buscarDocumentosAnalise(
                this.statusItem, 
                this.tipoAnalise, 
                this.paginaItensAnalise, 
                this.quantidadePorPagina)
			.then(resp => {		               
                this.analiseItens = resp.data.solicitacoes;
                this.totalItens = resp.data.totalItens;
                if(!this.exibirDialogItensAnalise) {
                    this.exibirDialogItensAnalise = true;
                }
			})
			.catch(erro => {exibirMensagem(this, erro)});
        },
        /**
         * 
         */
        buscarLotesAnalise() {
            this.filtro = {};  
            this.logsManutencaoService.buscarLotesAnalise(
                this.statusItem, 
                this.tipoAnalise, 
                this.paginaItensAnalise, 
                this.quantidadePorPagina)
			.then(resp => {		               
                this.analiseItens = resp.data.lotes;
                this.totalItens = resp.data.totalItens;
                if(!this.exibirDialogItensAnalise) {
                    this.exibirDialogItensAnalise = true;
                }
			})
			.catch(erro => {exibirMensagem(this, erro)});
        },
        /**
         * 
         */
        confirmarAcao(acao, itemSelecionado) {
            this.itemSelecionado = itemSelecionado;
            if(this.naoExibirConfirmarExcluirSelecionado 
                && acao == 'EXCLUIR_SELECIONADO') {
                this.excluir(acao);
                return;
            }
            if(this.naoExibirConfirmarReenviarSelecionado
                && acao == 'REENVIAR_SELECIONADO') {
                this.reenviarLoteParaFila();
                return;
            }
            if(acao == 'EXCLUIR_TODOS') {
                this.exibirConfirmarExcluirTodos = true;
            } else if(acao == 'REENVIAR_TODOS') {
                this.exibirConfirmarReenviarTodos = true;
            } else if(acao == 'EXCLUIR_SELECIONADO') {
                this.exibirConfirmarExcluirSelecionado = true;
            } else if(acao == 'REENVIAR_SELECIONADO') {
                this.exibirConfirmarReenviarSelecionado = true;
            }
        },
        /**
         * 
         */
        excluir(acao) {
            if(this.tipoDados == 'LOTE' && acao == 'EXCLUIR_TODOS') {
                this.finalizarLotesParaExcluir();
            } else if(this.tipoDados == 'LOTE' && acao == 'EXCLUIR_SELECIONADO') {
                this.finalizarLoteParaExcluir();
            } else if(this.tipoDados == 'DOCUMENTO' && acao == 'EXCLUIR_TODOS') {
                this.finalizarDocumentosParaExcluir();
            } else if(this.tipoDados == 'DOCUMENTO' && acao == 'EXCLUIR_SELECIONADO') {
                this.finalizarDocumentoParaExcluir();
            }
            this.exibirConfirmarExcluirTodos = false;
            this.exibirConfirmarExcluirSelecionado = false;            
        },
        /**
         * 
         */
        finalizarDocumentoParaExcluir() {
            this.logsManutencaoService.finalizarDocumentosParaExcluir(this.itemSelecionado.id)
			.then(() => {	 
                exibirMensagemSis(this, 'Sucesso', false);                        
                this.analiseItens = this.analiseItens.filter(item => item.id !== this.itemSelecionado.id);
			})
			.catch(erro => {exibirMensagem(this, erro)});
        },
        /**
         * 
         */
         finalizarDocumentosParaExcluir() {
            this.logsManutencaoService.finalizarDocumentosParaExcluir(null, this.statusItem, this.tipoAnalise)
			.then(() => {	 
                exibirMensagemSis(this, 'Sucesso. Aguarde o processametno.', false);                        
                this.analiseItens = [];
                setTimeout(() => {
                    this.statusFila();
                    this.exibirDialogItensAnalise = false;
                }, 1000);
			})
			.catch(erro => {exibirMensagem(this, erro)});
        },
        /**
         * 
         */
         finalizarLoteParaExcluir() {
            this.logsManutencaoService.finalizarLotesParaExcluir(this.itemSelecionado.id)
			.then(() => {	 
                exibirMensagemSis(this, 'Sucesso', false);                        
                this.analiseItens = this.analiseItens.filter(item => item.id !== this.itemSelecionado.id);
			})
			.catch(erro => {exibirMensagem(this, erro)});
        },
        /**
         * 
         */
         finalizarLotesParaExcluir() {
            this.logsManutencaoService.finalizarLotesParaExcluir(null, this.statusItem, this.tipoAnalise)
			.then(() => {	 
                exibirMensagemSis(this, 'Sucesso. Aguarde o processametno.', false);                        
                this.analiseItens = [];
                setTimeout(() => {
                    this.statusFila();
                    this.exibirDialogItensAnalise = false;
                }, 1000);
			})
			.catch(erro => {exibirMensagem(this, erro)});
        },
        /**
         * 
         */
        reenviarLoteParaFila() {
            this.exibirConfirmarReenviarSelecionado = false;
            this.logsManutencaoService.reenviarLotesParaFila(this.itemSelecionado.id)
			.then(() => {	 
                exibirMensagemSis(this, 'Sucesso', false);                        
                this.analiseItens = this.analiseItens.filter(item => item.id !== this.itemSelecionado.id);
			})
			.catch(erro => {exibirMensagem(this, erro)});
        },
        /**
         * 
         */
        reenviarLotesParaFila() {
            this.exibirConfirmarReenviarTodos = false;
            this.logsManutencaoService.reenviarLotesParaFila(null, this.statusItem, this.tipoAnalise)
			.then(() => {	 
                exibirMensagemSis(this, 'Sucesso. Aguarde o processametno.', false);                        
                this.analiseItens = [];
                setTimeout(() => {
                    this.statusFila();
                    this.exibirDialogItensAnalise = false;
                }, 1000);
			})
			.catch(erro => {exibirMensagem(this, erro)});
        },
        /**
         * 
         */
        proximaPagina(event) {
            this.paginaItensAnalise = event.page;
            if(this.tipoDados == 'DOCUMENTO') {
                this.buscarDocumentosAnalise();
                return;
            }
            if(this.tipoDados == 'LOTE') {
                this.buscarLotesAnalise();             
            }
        },
        /**
         * 
         */
        formatarDataHora(strData) {
            let dataFormatada = '';
			if(strData) {
				let partes = strData.split(' ');
				let partesData = partes[0].split('-');
                dataFormatada = partesData[2] + '/' + partesData[1] + '/' + partesData[0];
				if(partes[1]) {
                    dataFormatada += ' ' + partes[1];
                }
			}
			return dataFormatada;
		},
    },    
    created() {
        this.logsManutencaoService = new LogsManutencaoService();        
        this.statusFila();
    }
}
</script>

<style>
</style>